// assets
import { ContactsOutlined,MessageOutlined,UnorderedListOutlined,ExportOutlined,SendOutlined,SettingOutlined } from '@ant-design/icons';

// icons
const icons = {
    ContactsOutlined,MessageOutlined,UnorderedListOutlined,ExportOutlined,SendOutlined,SettingOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const sms = {
  id: 'group-sms',
  title: 'SMS ',
  type: 'group',
  children: [
    {
      id: 'sms-config',
      title: 'SMS Settings',
      type: 'collapse',
      icon: icons.SettingOutlined,
      children: [
        {
          id: 'sms-settings',
          title: 'SMS Account',
          type: 'item',
          url: '/sms-settings',
          icon: icons.MessageOutlined,
          breadcrumbs: true
        },
        {
          id: 'sender-settings',
          title: 'SenderID Settings',
          type: 'item',
          url: '/sender',
          icon: icons.ContactsOutlined,
          breadcrumbs: true
        },
        {
          id: 'sms-template-settings',
          title: 'Template ID Settings',
          type: 'item',
          url: '/templateid-settings',
          icon: icons.UnorderedListOutlined,
          breadcrumbs: true
        },
      ]
    },
     {
      id: 'send-sms-config',
      title: 'Send SMS',
      type: 'collapse',
      icon: icons.SettingOutlined,
      children: [
            {
            id: 'send-sms',
            title: 'Send Bulk SMS',
            type: 'item',
            url: '/send-bulk-sms',
            icon: icons.SendOutlined,
            breadcrumbs: true
            },
            {
            id: 'send-personalized-sms',
            title: 'Send Personalized SMS',
            type: 'item',
            url: '/send-personalized-sms',
            icon: icons.SendOutlined,
            breadcrumbs: true
            }
        ]
    }
    // {
    //   id: 'sms',
    //   title: 'Send Custom SMS',
    //   type: 'item',
    //   url: '/custom-sms',
    //   icon: icons.SendOutlined,
    //   breadcrumbs: true
    // } - SSSUle SMS Utility
  ]
};

export default sms;
